import { useDashboardContext } from 'lib/context/Dashboard/DashboardContext';

import DropdownTabs from 'components/shared/AgTablePage/components/DropdownTabs';

const FilterViews = () => {
  const { filters, setFilters, defaultFilters, setInitialFilters, setIsEditingFilter } =
    useDashboardContext();

  const items = [{ label: 'All appointments & events', value: null }];

  return (
    <div className="border-0 border-r border-solid border-r-neutral-100 pr-2">
      <DropdownTabs
        defaultActiveItem="All appointments & events"
        items={items}
        category="dashboard_calendar"
        filters={filters}
        setFilters={setFilters}
        defaultFilters={defaultFilters}
        setInitialFilters={setInitialFilters}
        setIsEditingFilter={setIsEditingFilter}
        removeDefaults
      />
    </div>
  );
};

export default FilterViews;
